import { useQueryClient, useMutation } from '@tanstack/react-query';
import { fetcher } from '../utils';
import {
  ADMIN_GATHERING_SPOT_TYPES_DELETE,
  GATHERING_SPOT_TYPE,
  GATHERING_SPOT_TYPES_ALL,
} from '../queryKeys';

export const useAdminDeleteGatheringSpotType = () => {
  const queryClient = useQueryClient();

  const mutationFn = async (gathering_spot_type_id: string): Promise<void> => {
    const response = await fetcher(
      `/v2/admin/gathering_spot_types/${gathering_spot_type_id}`,
      {
        method: 'DELETE',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
      },
    );

    if (response.status !== 204)
      throw new Error((await response.json()).error ?? 'Did not work!');

    queryClient.invalidateQueries({ queryKey: GATHERING_SPOT_TYPES_ALL });
    queryClient.invalidateQueries({
      queryKey: GATHERING_SPOT_TYPE,
      exact: false,
    });
  };

  const { mutate, error, status, isPending, isSuccess, isError } = useMutation({
    mutationKey: ADMIN_GATHERING_SPOT_TYPES_DELETE,
    mutationFn,
  });

  return { mutate, error, status, isPending, isSuccess, isError };
};
